import React from 'react';

export function NexusModal({ open, children, onClose, maxWidth = 920 }) {
  if (!open) return null;
  return (
    <div className="nexus-react-modal" onClick={event => event.target === event.currentTarget && onClose?.()}>
      <div className="guest-modal-card" style={{ maxWidth }}>
        <div className="guest-modal-scroll" style={{ padding: 24 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
